import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges
} from '@angular/core';

@Component({
	selector: 'pcm-table-filter-field-date',
	templateUrl: './table-filter-field-date.component.html',
	styleUrls: ['./table-filter-field-date.component.scss']
})
export class TableFilterFieldDateComponent implements OnChanges {
	@Input() name: string;
	@Input() value: any = {};
	@Input() helpMessage: string;
	@Input() dateFiltering: Function;
	@Input() dateFormatter: Function;
	@Input() showAsRange = false;
	@Output() valueChange = new EventEmitter<any>();
	@Output() onDateSelected = new EventEmitter<void>();
	dateOptionsRangeStart: any = {};
	dateOptionsRangeEnd: any = {};

	ngOnChanges(changes: SimpleChanges) {
		if (changes['dateFiltering']) {
			this.updateDateOptions();
		}
	}

	getValue(prop): any {
		if (this.value === undefined || this.value === null) {
			return undefined;
		} else {
			return this.value[prop];
		}
	}

	/**
	 * handle a value change from the child date components
	 */
	changeValue(value, changingProp): void {
		// format into our date string format YYYY-mm-dd
		const formattedDate = value ? this.dateFormatter(value) : undefined;
		const returnValue = this.value ? this.value : { startDate: undefined, endDate: undefined };
		returnValue[changingProp] = formattedDate;

		// in case of range filtering, update start/end ranges to make sure they aren't inverted
		this.updateDateOptions(changingProp, formattedDate);

		this.valueChange.emit(returnValue);
		this.onDateSelected.emit();
	}

	/**
	 * handle situations when the date options need to change, including if the input property 'dateFiltering'
	 * changes, or if one of the dates in a Range changes
	 */
	updateDateOptions(rangePropToSet = undefined, rangeDate = undefined) {
		this.dateOptionsRangeStart = {};
		this.dateOptionsRangeEnd = {};
		if (this.dateFiltering) {
			this.dateOptionsRangeStart['enable'] = [ this.dateFiltering ];
			this.dateOptionsRangeEnd['enable'] = [ this.dateFiltering ];
		}
		// these allow updating of dates and clearing of dates in a range
		if (this.showAsRange && rangePropToSet === 'startDate') {
			this.dateOptionsRangeEnd['minDate'] = rangeDate;
		}
		if (this.showAsRange && rangePropToSet === 'endDate') {
			this.dateOptionsRangeStart['maxDate'] = rangeDate;
		}
	}

	/**
	 * This is a hacky way of forcing the date component calendar to start on Saturday. Carbon Angular's datepicker
	 * wraps Flatpickr, which allows setting this on the locale config. However, Carbon's Angular component overrides this
	 * locale setting, so the only method of editing it is to create a Flatpickr plugin and edit the config on the
	 * Flatpickr internal instance object. Hopefully the Carbon Angular component will allow setting a custom locale
	 * setting in the future, and this hacky method can be removed.
	 */
	datePickerPluginForceStartSaturday(fp) {
		return {
			// event hook
			onParseConfig() {
				fp.config.locale.firstDayOfWeek = 6; // zero-based day of week, 6=saturday
			}
		};
	}
}
